<template>
  <div class="section">
    <header-page>
      <span class="text-dark fw-bold-700 size14">Daftar Pembayaran ke Pemasok</span>
    </header-page>

    <keep-alive>
      <component :is="comp" />
    </keep-alive>
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BDropdown, BDropdownItem, BImg, BPagination, BFormSelect, BModal, VBToggle, BRow, BCol,
} from 'bootstrap-vue'

import HeaderPage from '@/components/HeaderPage.vue'
import TablePayoutSupplier from '@/components/Payout/Supplier/TablePayoutSupplier.vue'

export default {
  title() {
    return 'Pembayaran ke Pemasok'
  },
  components: {
    BButton,
    HeaderPage,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BImg,
    BPagination,
    BFormSelect,
    BModal,
    BRow,
    BCol,
    TablePayoutSupplier,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      comp: 'TablePayoutSupplier',
    }
  },
  computed: {
  },
  created() {
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

</style>
